/**
 * IntegrationsAlertsPanel — the 'alerts' area panel.
 *
 * One SettingsSection per `areas.ts` 'alerts' registry entry. CX
 * notifications + remedies mirror the old god component's
 * `CxNotificationsContent` wrapper (heading + Separator between the two).
 */
import { Mail } from 'lucide-react';
import { Separator } from '@/components/ui/separator';
import { SettingsSection } from '../components/console/SettingsSection';
import { CxNotificationSettingsSection, CxRemediesSection } from '../components/CxNotificationSection';
import { SlackNotificationsSection } from '../sections/SlackNotificationsSection';
import { AlertThresholdsSection } from '../sections/AlertThresholdsSection';

export function IntegrationsAlertsPanel() {
  return (
    <>
      <SlackNotificationsSection />

      <SettingsSection
        id="cx-notifications"
        title="Customer notifications"
        description="Emails sent to customers on production issues, plus remedy options."
        icon={Mail}
        scope="org"
      >
        <div className="space-y-6">
          <CxNotificationSettingsSection />
          <Separator />
          <div>
            <h4 className="mb-3 font-medium">Remedy options</h4>
            <CxRemediesSection />
          </div>
        </div>
      </SettingsSection>

      <AlertThresholdsSection />
    </>
  );
}
